// ========= START: src/components/FinalStatsScreen.js (COMPLETE REPLACEMENT) =========
import React, { useRef } from 'react';
import html2canvas from 'html2canvas';

function TimeBar({ time }) {
  const maxTime = 10; 
  const widthPercent = Math.min(100, (time / maxTime) * 100);

  let barColorClass = 'time-bar-fast';
  if (time > 7) barColorClass = 'time-bar-slow';
  else if (time > 3) barColorClass = 'time-bar-medium';

  return (
    <div className="stats-bar-container">
      <div className={`stats-bar-fill ${barColorClass}`} style={{ width: `${widthPercent}%` }} />
    </div>
  );
}

function FinalStatsScreen({ finalScore, wordList, onMainMenu, playerData }) {
  
  const statsPanelRef = useRef(null);

  const handleScreenshot = () => {
    const statsPanel = statsPanelRef.current;
    if (!statsPanel) return;
    const scrollableList = statsPanel.querySelector('.stats-results-list');
    if (!scrollableList) return;

    // Capture all original style values that we are about to change
    const originalPanelHeight = statsPanel.style.height;
    const originalPanelMaxHeight = statsPanel.style.maxHeight; // Capture original max-height
    const originalListOverflow = scrollableList.style.overflowY;
    const originalListMaxHeight = scrollableList.style.maxHeight;

    // Temporarily remove all height and scroll restrictions to reveal the entire content
    statsPanel.style.height = 'auto';
    statsPanel.style.maxHeight = 'none'; // THIS IS THE KEY FIX
    scrollableList.style.overflowY = 'visible';
    scrollableList.style.maxHeight = 'none';

    html2canvas(statsPanel, { useCORS: true, backgroundColor: null, scale: 2 })
    .then(canvas => {
      const link = document.createElement('a');
      link.download = 'pronunciation-challenge-score.png';
      link.href = canvas.toDataURL('image/png');
      link.click();
    }).finally(() => {
        // IMPORTANT: Restore all original styles to return the UI to normal
        statsPanel.style.height = originalPanelHeight;
        statsPanel.style.maxHeight = originalPanelMaxHeight; // Restore original max-height
        scrollableList.style.overflowY = originalListOverflow;
        scrollableList.style.maxHeight = originalListMaxHeight;
    });
  };

  const getMasteryInfo = (wordId) => {
    const masteryData = (playerData.wordMastery && playerData.wordMastery[wordId]);
    if (!masteryData) return { level: 'New', icon: '🆕', className: 'mastery-new' };
    
    switch (masteryData.level) {
      case 'Mastered': return { level: 'Mastered', icon: '⭐', className: 'mastery-mastered' };
      case 'Practiced': return { level: 'Practiced', icon: '👍', className: 'mastery-practiced' };
      case 'Learning': return { level: 'Learning', icon: '📖', className: 'mastery-learning' };
      default: return { level: 'New', icon: '🆕', className: 'mastery-new' };
    }
  };

  return (
    <div className="final-stats-screen" ref={statsPanelRef}> 
      <div className="stats-header-container">
        <h1 className="stats-header-title">Round Complete!</h1>
        <div className="stats-player-info">
          <span className="stats-player-name">{playerData.username}</span>
          <span className="stats-player-level">Level: {playerData.level}</span>
        </div>
        <p className="stats-score-text">Final Score: {finalScore}</p>
      </div>

      <div className="stats-results-list-header">
          <span className="header-word">Word</span>
          <span className="header-time">Time</span>
          <span className="header-score">Score</span>
      </div>

      <div className="stats-results-list">
        {wordList.map((item, index) => {
          const mastery = getMasteryInfo(item.id);
          return (
            <div key={index} className={`stats-word-row ${item.status}`}>
              <span className={`stats-word-text ${mastery.className}`}>
                <span className="mastery-icon" title={`Mastery: ${mastery.level}`}>{mastery.icon}</span>
                {item.isPerfect && <span className="perfect-bonus-star" title="Perfect Bonus!">✨</span>}
                {item.word}
              </span>
              <div className="stats-word-performance">
                  <TimeBar time={item.time} />
                  <span className="stats-word-score">{item.score > 0 ? `${item.score} pts` : '-'}</span>
              </div>
            </div>
          );
        })}
      </div>

      <div className="stats-footer-container">
        <button className="stats-button" onClick={handleScreenshot}>Capture Score</button>
        <button className="stats-button" onClick={onMainMenu}>Main Menu</button>
      </div>
    </div>
  );
}

export default FinalStatsScreen;
// ========= END: src/components/FinalStatsScreen.js (COMPLETE REPLACEMENT) =========